import { useCallback, useState } from "react";
import { getPresignedImage } from "../utils/media";
import { message } from "antd";

export const useViewAttachDocument = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const viewAttachDocument = useCallback(async (documentId: string | string[]) => {
    setLoading(true);
    setError(null);

    try {
      const ids = Array.isArray(documentId) ? documentId : [documentId];
      const documentDetails = await getPresignedImage(ids, true, true);

      if (!documentDetails || !documentDetails.length) {
        message.error("No document found");
      }

      documentDetails.forEach((doc) => {
        if (doc?.location) window.open(doc.location, "_blank");
      });
    } catch (err: any) {
      console.error("❌ Error viewing document:", err);
      setError(err.message || "Failed to open document");
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    viewAttachDocument,
    loading,
    error,
  };
};
